import articleWispehone from "./work-articles/articleWisephone";
import articleBulletins from "./work-articles/articleBulletins";
import articleMandyLynn from "./work-articles/articleMandyLynn";
import articleTechAddictionQuiz from "./work-articles/articleTechAddictionQuiz";
import articleAnimationShowcase from "./work-articles/articleAnimationShowcase";
import articleSignatureBuilder from "./work-articles/articleSignatureBuilder";
import articleKirkElliott from "./work-articles/articleKirkElliott";
import articleMusicVideo from "./work-articles/articleMusicVideo";

const work_all = [
  articleKirkElliott,
  articleWispehone,
  articleMusicVideo,
  articleBulletins,
  articleMandyLynn,
  articleTechAddictionQuiz,
  articleAnimationShowcase,
  articleSignatureBuilder
]
export default work_all;